import {Component, effect, input, signal} from '@angular/core'
import {MatError, MatFormField, MatHint, MatInput, MatLabel, MatSuffix} from '@angular/material/input'
import {FieldTree, FormField} from '@angular/forms/signals'
import {FormsModule} from '@angular/forms'
import {verify} from '@sparbanken-syd/personnummer'

@Component({
  selector: 'spb-input-field',
  imports: [
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    MatSuffix,
    FormField,
    FormsModule,
    MatHint
  ],
  templateUrl: './input-field.html'
})
export class InputField {
  /**
   * What to put in the label field.
   */
  public label = input.required<string>()
  /**
   * The field from your form.
   */
  public field = input.required<FieldTree<string, string>>()

  /**
   * To replace personnummer with a 13 digit personnummer.
   */
  public personNummer = input<boolean>(false)

  public name = input<FieldTree<string, string>>(() => ({value: signal('')} as any))

  // To avoid field()() syntax
  get f() {
    return this.field()
  }

  // To avoid field()() syntax
  get n() {
    return this.name()()
  }

  get b() {
    return this.f().touched() && this.f().invalid()
  }

  constructor() {
    effect(() => {
      if (this.personNummer() && this.f().valid() && this.f().value().length >= 10) {
        const p = verify(this.f().value())
        if (p[13] !== this.f().value()) {
          this.f().value.set(p[13])
        }
      }
    })
  }
}
